import { render, staticRenderFns } from "./StoreLocatorButton.vue?vue&type=template&id=11e775f6"
import script from "./StoreLocatorButton.vue?vue&type=script&lang=ts"
export * from "./StoreLocatorButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e775f6')) {
      api.createRecord('11e775f6', component.options)
    } else {
      api.reload('11e775f6', component.options)
    }
    module.hot.accept("./StoreLocatorButton.vue?vue&type=template&id=11e775f6", function () {
      api.rerender('11e775f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/StoreLocatorButton.vue"
export default component.exports